/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowHolidayPartyTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowHolidayParty,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Celebrate the Holidays!",
    "Festive Fun Awaits!",
    "Holiday Cheer is Here!",
  ],
  title: "Holiday Party",
  description: "Organize a festive holiday party.",
  longDescription:
    "Gather your friends for a joyful holiday celebration! Choose a date, plan the activities, and decide on food and drinks!",
  emoji: "🎉",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Holiday Party",
          emoji: "🎉",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the holiday party?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities for the party?",
            description:
              "What activities should we include in our holiday celebration?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we plan?",
                emoji: "🎄",
                completeAction: {
                  question: "Decide on food and drinks?",
                  description: "What food and drinks should we serve?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What food should we have?",
                      emoji: "🍽",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "🍹",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Happy Holidays!",
    outroDescription:
      "Your holiday party plans are set! Enjoy the festivities!",
  },
};
